export enum CryptoTokenType {
  SOFT = 'SOFT',
  PKCS11 = 'PKCS11',
}

export const CryptoTokenTypeList = [
  {
    value: CryptoTokenType.SOFT,
    label: 'SOFT',
  },
  {
    value: CryptoTokenType.PKCS11,
    label: 'PKCS#11',
  },
];
